<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} PRODUCT CATEGORY</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <span class="px-2" style="font-size:12px">Active?</span>
        <vs-switch color="primary" color-off="danger" v-model="dataIsActive">
        <span slot="on">On</span>
        <span slot="off">Off</span>
        </vs-switch>
        <span class="px-2" style="font-size:12px">Sumal Required when Transported?</span>
        <vs-switch color="primary" color-off="danger" v-model="dataNeedSumal">
        <span slot="on">On</span>
        <span slot="off">Off</span>
        </vs-switch>
        <!-- SHAPE -->
        <vs-select v-model="dataShape" label="Shape" class="mt-5 w-full" name="shape">
          <vs-select-item :key="item.id" :value="item.id" :text="item.name_en" v-for="item in data_options_shapes" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('shape')">{{ errors.first('shape') }}</span>
        <img v-if=(dataShape) :src="getImgUrl()"/>
        <!-- NAME EN -->
        <vs-input label="Name EN *" v-model="dataNameEN" class="mt-5 w-full" name="name_en"  v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('name_en')">{{ errors.first('name_en') }}</span>
        <!-- NAME FR -->
        <vs-input label="Name FR" v-model="dataNameFR" class="mt-5 w-full" name="name_fr"/>
        <span class="text-danger text-sm" v-show="errors.has('name_fr')">{{ errors.first('name_fr') }}</span>
        <!-- NAME RO -->
        <vs-input label="Name RO" v-model="dataNameRO" class="mt-5 w-full" name="name_ro"/>
        <span class="text-danger text-sm" v-show="errors.has('name_ro')">{{ errors.first('name_ro') }}</span>
        <!-- NAME ES -->
        <vs-input label="Name ES" v-model="dataNameES" class="mt-5 w-full" name="name_es"/>
        <span class="text-danger text-sm" v-show="errors.has('name_es')">{{ errors.first('name_es') }}</span>
        <!-- NAME DE -->
        <vs-input label="Name DE" v-model="dataNameDE" class="mt-5 w-full" name="name_de"/>
        <span class="text-danger text-sm" v-show="errors.has('name_de')">{{ errors.first('name_de') }}</span>
        <!-- NAME NL -->
        <vs-input label="Name NL" v-model="dataNameNL" class="mt-5 w-full" name="name_nl"/>
        <span class="text-danger text-sm" v-show="errors.has('name_nl')">{{ errors.first('name_nl') }}</span>
        <!-- NAME PUNJABI -->
        <vs-input label="Name Punjabi" v-model="dataNamePunjabi" class="mt-5 w-full punjabi-input" name="name_punjabi"/>
        <span class="text-danger text-sm" v-show="errors.has('name_punjabi')">{{ errors.first('name_punjabi') }}</span>
        <!-- REF PRICE -->
        <!--<vs-input label="Price (euro / m3)" v-model="dataPrice" class="mt-5 w-full" name="price" v-validate="'decimal'"/>
        <span class="text-danger text-sm" v-show="errors.has('price')">{{ errors.first('price') }}</span>-->

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from '@/axios.js'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      data_options_shapes: [],
      dataId: null,
      dataNameFR: '',
      dataNameRO: '',
      dataNameEN: '',
      dataNameES: '',
      dataNameDE: '',
      dataNameNL: '',
      dataNamePunjabi: '',
      dataPrice: '',
      dataNeedSumal:false,
      dataIsActive:true,
      dataShape: null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.dataId = null
      } else {
        const { id, name_en, name_fr, name_ro,name_es,name_de,name_nl, name_punjabi, isactive, price, idproductcategoryshape,needsumal } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id,
        this.dataNameEN = name_en,
        this.dataNameFR = name_fr,
        this.dataNameRO = name_ro,
        this.dataNeedSumal=needsumal,
        this.dataNameES = name_es,
        this.dataNameDE = name_de,
        this.dataNameNL = name_nl,
        this.dataNamePunjabi = name_punjabi,
        this.dataIsActive = isactive,
        this.dataPrice = price,
        this.dataShape = idproductcategoryshape,
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataNameEN && this.dataShape
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
  },
  methods: {
    async getOptionsShapes()
    {
      axios.get('/product/shapes/data')
        .then((response) => {
          this.data_options_shapes = [...response.data]
        })
    },
    getImgUrl() {
      if (this.dataShape)
      {
        var images = require.context('@/assets/images/icons/shapes/', false, /\.png$/)
        return images('./' + this.dataShape + ".png")
      }
    },
    initValues () {
      if (this.data.id) return
        this.dataId = '',
        this.dataNameEN = '',
        this.dataNameFR = '',
        this.dataNameRO = '',
        this.dataNameES = '',
        this.dataNameDE = '',
        this.dataNameNL = '',
        this.dataNamePunjabi = '',
        this.dataPrice = '',
        this.dataShape = null,
        this.dataNeedSumal = false,
        this.dataIsActive = true
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name_en: this.dataNameEN,
            name_fr: this.dataNameFR,
            name_ro: this.dataNameRO,
            name_es: this.dataNameES,
            name_de: this.dataNameDE,
            name_nl: this.dataNameNL,
            name_punjabi: this.dataNamePunjabi,
            price: this.dataPrice,
            needsumal: this.dataNeedSumal,
            idproductcategoryshape: this.dataShape,
            isactive: this.dataIsActive
          }
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('dataListProductCategory/updateItem', obj).catch(err => { console.error(err) })
            this.$vs.notify({
              color: 'success',
              title: 'Product Category Updated!',
              text: 'The category was successfully edited'
            })
          }
          else {
            delete obj.id
            this.$store.dispatch('dataListProductCategory/createItem', obj).catch(err => { console.error(err) })
            this.$vs.notify({
              color: 'success',
              title: 'Product Category Created!',
              text: 'The category was successfully added'
            })
          }
          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    }
  },
  created () {
    this.getOptionsShapes();
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}

// Style for Punjabi input
.punjabi-input {
  ::v-deep .vs-input__input {
    font-family: 'Noto Sans Gurmukhi', sans-serif !important;
    font-size: 14px;
  }

  ::v-deep .vs-input__label {
    font-family: 'Noto Sans Gurmukhi', sans-serif !important;
  }
}
</style>
